export const powerManagementPolicyEnum = {
  1: 'Equal Charge Algorithm',
  2: 'First-in-first-out Algorithm',
  3: 'Utility Tariff Optimized Algorithm',
  4: 'Non-charger Share Optimized Algorithm'
};
